export function Shield({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.73984 1.85781L4.58151 3.42448C3.62318 3.78281 2.83984 4.91615 2.83984 5.93281V12.1245C2.83984 13.1078 3.48984 14.3995 4.28151 14.9911L7.86484 17.6661C9.03984 18.5495 10.9732 18.5495 12.1482 17.6661L15.7315 14.9911C16.5232 14.3995 17.1732 13.1078 17.1732 12.1245V5.93281C17.1732 4.90781 16.3898 3.77448 15.4315 3.41615L11.2732 1.85781C10.5648 1.59948 9.43151 1.59948 8.73984 1.85781Z"
          stroke="var(--clr-general-primary)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
